<script>
  export let campaign;
  import ItemList from './ItemList.svelte';
  import ButtonList from './ButtonList.svelte';
</script>

<h2>{campaign.title}</h2>
<p class="description">{campaign.description} organized by <ItemList items={campaign.organizers}/>.</p>
<h3 class="small-heading">Ways to donate</h3>
<p class="donate-buttons"><ButtonList buttons={campaign.donateMethods}/></p>
<hr>

<style>
  .donate-buttons {
    text-transform: uppercase;
  }
  .small-heading {
    text-transform: uppercase;
    font-weight: normal;
    font-size: 0.8em;
    color: #666;
  }
  .description {
    margin: 0 auto 1.2em;
    max-width: 80%;
    font-weight: 300;
    color: #333;
  }
  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }

  hr {
    border-width: 0;
    background: #ddd;
    color: #ddd;
    height: 1px;
    margin: 30px 0;
  }

</style>
